import { FormattedHTMLMessage } from '@99designs/common/i18n/index';
import { getLocale } from 'common/utils/getLocale';
import React from 'react';

class SmartShootUSOnly extends React.Component {
    render() {
        return getLocale() != 'en-us' ? this.renderUSOnlyMessage() : this.props.children;
    }

    renderUSOnlyMessage() {
        return (
            <div className="hero-layout">
                <div className="row">
                    <div className="column">
                        <FormattedHTMLMessage
                            message={__(
                                "It seems the brief you're looking for is only accessible within the US. If you feel this is a problem, feel free to <a href='{contactUrl}' class='link link--default'>contact support</a>.."
                            )}
                            values={{
                                contactUrl:
                                    'https://support.99designs.com/hc/en-us/requests/new?ticket_form_id=180343',
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default SmartShootUSOnly;
